import { Polyline, Tooltip, useMapEvents, CircleMarker } from 'react-leaflet'
import { useState } from 'react'

const LineDraw = () => {
  const [start, setStart] = useState(null)
  const [end, setEnd] = useState(null)
  const [isDrawing, setIsDrawing] = useState(false)
  const [dist, setDist] = useState(0)

  const map = useMapEvents({
    click(e) {
      if (start === null) {
        setStart(e.latlng)
        setIsDrawing(true)
      } else if (end === null) {
        setEnd(e.latlng)
        setIsDrawing(false)
      } else if (isDrawing === true) {
        setIsDrawing(false)
      } else {
        setIsDrawing(true)
        setStart(e.latlng)
        setEnd(e.latlng)
        setDist(0)
      }
    },
    mousemove(e) {
      if (start !== null && isDrawing) {
        setEnd(e.latlng)
        setDist(start.distanceTo(e.latlng))
      }
    },
  })

  return (
    <>
      {start && end && (
        <>
          <CircleMarker
            center={start}
            pathOptions={{ color: 'green' }}
            radius={0}
          ></CircleMarker>
          <CircleMarker
            center={end}
            pathOptions={{ color: 'green' }}
            radius={0}
          >
            <Tooltip
              position={end}
              permanent
              sticky
              offset={[0, 20]}
              opacity={1}
            >
              {'Distance : ' + Math.round(dist) + ' m'}
            </Tooltip>
          </CircleMarker>
          <Polyline positions={[start, end]} weight={1} color={'green'} />
        </>
      )}
    </>
  )
}

export default LineDraw
